import { objectSchema, optionalTolerant, tolerantEnum } from '../../_utils/fcdc-v2'
import * as z from 'zod'

const emailStatus = {
  Unverified: 'Unverified',
  PendingVerification: 'PendingVerification',
  Verified: 'Verified',
}

const phoneStatus = {
  Unverified: 'Unverified',
  PendingVerification: 'PendingVerification',
  Verified: 'Verified',
}

export const emailSchema = objectSchema({
  status: tolerantEnum(emailStatus),
  address: optionalTolerant(z.string()),
  code: optionalTolerant(z.string()),
})

export const phoneSchema = objectSchema({
  status: tolerantEnum(phoneStatus),
  number: optionalTolerant(z.string()),
  code: optionalTolerant(z.string()),
})
